<template>
  <div class="flex items-center min-h-screen">
    <div class="flex flex-col mx-auto">
      <div class="header">Lo sentimos, página no encontrada.</div>
      <router-link :to="redirectRoute" class="mx-auto mt-8 link">{{ redirectLabel }}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    redirectRoute() {
      if (!this.$store.state.user) return { name: "login" };
      const branchId = this.$store.state.branches?.[0]?.id;
      return branchId
        ? { name: "dashboard", params: { branchId } }
        : { name: "login" };
    },
    redirectLabel() {
      return this.$store.state.user ? "Ir al dashboard" : "Ir a inicio de sesión";
    },
  },
};
</script>
